import React from "react";

import "../styles.scss";
import "../scripts";

import {
  secondaryBlock,
  SecondaryBlockSize,
  KameleonElement,
  SecondaryBlockConfig,
  getDefaultProps,
} from "@kameleon-core/lib";
import { Box } from "theme-ui";
import { Variants } from "@kameleon-util/global-theme";
import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import { ButtonsType, layoutOptions } from "./types/prop-types";

/** Buttons Secondary */
const blockConfig: SecondaryBlockConfig = {
  blockSize: [
    SecondaryBlockSize.ExtraSmall,
    SecondaryBlockSize.Small,
    SecondaryBlockSize.Medium,
    SecondaryBlockSize.Large,
  ],
};

export const Buttons = secondaryBlock<ButtonsType>(
  blockConfig,
  ({
    primaryButtonLink,
    primaryButtonText,
    secondaryButtonLink,
    secondaryButtonText,
    tertiaryButtonLink,
    tertiaryButtonText,
  }: ButtonsType) => (
    <Box className="secondary-buttons-default-v1">
      <Variants.ButtonGroup
        primaryButtonText={primaryButtonText}
        primaryButtonLink={primaryButtonLink}
        secondaryButtonText={secondaryButtonText}
        secondaryButtonLink={secondaryButtonLink}
        tertiaryButtonText={tertiaryButtonText}
        tertiaryButtonLink={tertiaryButtonLink}
      />
    </Box>
  )
);

Buttons.defaultProps = getDefaultProps<ButtonsType>(defaults);

export const Element: KameleonElement = {
  component: Buttons,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
